import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { UNIVERSES } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4", "lg:col-span-5", "lg:col-span-7"];

const UniverseCard = ({ u, index, span }) => (
  <Reveal delay={(index % 3) * 0.08} className={span}>
    <figure className="group relative h-full overflow-hidden bg-card" data-testid={`univers-card-${u.id}`}>
      <div className="aspect-[16/11] w-full overflow-hidden lg:aspect-[16/10]">
        <img src={u.image} alt={u.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-[1.05]" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent" />
      <span className="absolute left-6 top-6 font-mono text-[10px] tracking-[0.3em] text-neon-light">{String(index + 1).padStart(2, "0")}</span>
      <figcaption className="absolute inset-x-0 bottom-0 p-6 lg:p-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">{u.kicker}</p>
        <h3 className="mt-2 font-serif text-2xl text-cream sm:text-3xl">{u.name}</h3>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-white/60">{u.description}</p>
      </figcaption>
    </figure>
  </Reveal>
);

export const Universes = () => {
  const navigate = useNavigate();
  return (
    <section id="univers" className="scroll-mt-20 border-y border-white/10 bg-[#1D1327] py-24 lg:py-36" data-testid="section-univers">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow>Les univers</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
                Un logement atypique, ce n'est pas une déco. C'est un univers complet dans lequel on a envie de plonger.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.16}>
              <p className="leading-relaxed text-white/55">
                Deux ou trois objets, des LEDs rouges et un jacuzzi ne suffisent pas. Une seule règle : créer une expérience
                qu'on ne trouve nulle part ailleurs. Quel que soit le thème, le principe reste le même.
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="mt-6 font-serif text-2xl italic leading-snug text-neon-light">
                On ne vend pas une nuit. On vend un moment que les gens n'oublieront pas.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-12" data-testid="univers-grid">
          {UNIVERSES.map((u, i) => (
            <UniverseCard key={u.id} u={u} index={i} span={SPANS[i]} />
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
            <button onClick={() => navigate("/rendez-vous")} data-testid="univers-cta" className="btn-primary">
              Trouver mon univers <ArrowRight className="h-4 w-4" />
            </button>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
              Univers présentés dans notre webinaire — réalisations de la marque et de nos clients
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
